module.exports = __webpack_public_path__ + "img/Asset_active.b4139c44.svg";